import { useEffect, useRef } from "react";

type AdSlotProps = {
  slot: "banner_top" | "incontent_1" | "sidebar_1";
  className?: string;
};

const AdSlot = ({ slot, className = "" }: AdSlotProps) => {
  const ref = useRef<HTMLDivElement>(null);
  const publisherId = import.meta.env.VITE_ADSENSE_PUBLISHER_ID as
    | string
    | undefined;
  const isProd = import.meta.env.PROD;

  useEffect(() => {
    if (!publisherId || !isProd) return;

    // Load AdSense script once
    if (!document.querySelector('script[data-adsbygoogle]')) {
      const s = document.createElement("script");
      s.src = "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=" +
        encodeURIComponent(publisherId);
      s.async = true;
      s.crossOrigin = "anonymous";
      s.setAttribute("data-adsbygoogle", "true");
      document.head.appendChild(s);
    }

    // Request ad
    const timer = setTimeout(() => {
      try {
        // @ts-ignore
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      } catch (e) {
        // ignore
      }
    }, 0);
    return () => clearTimeout(timer);
  }, [publisherId, isProd]);

  const reserved =
    slot === "banner_top"
      ? "min-h-[90px] md:min-h-[120px]"
      : slot === "sidebar_1"
      ? "min-h-[250px]"
      : "min-h-[280px]";

  if (!publisherId || !isProd) {
    return (
      <div
        ref={ref}
        className={`ad-placeholder ${reserved} w-full border rounded-md grid place-items-center text-xs text-muted-foreground bg-accent ${className}`}
        aria-label={`AdSense placeholder: ${slot}`}
      >
        AdSense placeholder — {slot}
      </div>
    );
  }

  return (
    <div className={`${reserved} w-full ${className}`}>
      <ins
        className="adsbygoogle block"
        style={{ display: "block" }}
        data-ad-client={publisherId}
        data-ad-slot={slot}
        data-ad-format="auto"
        data-full-width-responsive="true"
      />
    </div>
  );
};

export default AdSlot;
